import { first, get, join, upperFirst, memoize } from 'lodash';

import { Profile, UserSimple } from '~/types/models';
import { KeysWithValsOfType } from '~/utils/types';

export function getNameFromEmail(email: string) {
  const lhs = first(email.split('@'));
  const segments = lhs?.split('.').map(upperFirst);

  return join(segments, ' ');
}

type ProfileStringKeys = KeysWithValsOfType<Profile, string | null>;

export type ProfileOrUser = Profile | UserSimple;

const getProfileStringAttribute = memoize(
  (obj: ProfileOrUser, key: ProfileStringKeys) => (get(obj, key) || String()).trim(),
  (obj: ProfileOrUser, key: ProfileStringKeys) =>
    `${get(obj, 'id')}_${key}_${get(obj, key)}`
);

const getFirstName = (profile: ProfileOrUser) =>
  getProfileStringAttribute(profile, 'first_name');
const getLastName = (profile: ProfileOrUser) =>
  getProfileStringAttribute(profile, 'last_name');

function hasFirstName(profile: ProfileOrUser) {
  return getFirstName(profile).length > 0;
}

export const getProfileName = (profile: ProfileOrUser) =>
  !hasFirstName(profile)
    ? getNameFromEmail(getProfileStringAttribute(profile, 'email'))
    : `${getFirstName(profile)} ${getLastName(profile)}`.trim();

export const getProfileFirstName = (profile: ProfileOrUser) =>
  !hasFirstName(profile)
    ? getNameFromEmail(getProfileStringAttribute(profile, 'email'))
    : getFirstName(profile);
